import { useUser } from "@/contexts/UserContext";
import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router";
import { useTranslation } from "react-i18next";

export const RequireUser = () => {
  const location = useLocation();
  const { user, login } = useUser();
  const { t } = useTranslation("common");

  useEffect(() => {
    const checkUser = async () => {
      if (!user) {
        login();
      }
    };

    checkUser();
  }, [user, location.pathname, login]);

  if (!user) {
    return <div>{t("status.loading")}</div>;
  }

  return <Outlet />;
};
